<div class="w-full user-profile-container">
  <og-card pageTitle="Profile">
    <div
      class="w-full mx-auto px-[0.75rem] min-[576px]:max-w-[540px] min-[768px]:max-w-[720px] min-[992px]:max-w-[960px] min-[1200px]:max-w-[1140px] min-[1400px]:max-w-[1320px] mx-auto flex flex-col items-center justify-center p-2 mt-[1.5rem] bg-white shadow-lg"
      *ngIf="userData"
    >
      <!-- Avatar -->
      <div class="flex w-full justify-center -mt-12">
        <div
          class="relative flex items-center justify-center w-44 h-44 overflow-hidden rounded-full ring-4 ring-bg-card"
        >
          <img
            class="object-cover w-full h-full"
            [src]="
              userData.coach.avatar ?? 'assets/images/avatar/avatar-male-profile-gray-person.jpg'
            "
            alt="avatar"
          />
          <!-- Upload / avatar -->
          <div class="absolute inset-0 z-10 bg-black bg-opacity-50"></div>
          <div class="absolute inset-0 z-20 flex items-center justify-center">
            <div>
              <input
                id="profile-avatar-file-input"
                class="absolute w-0 h-0 opacity-0 pointer-events-none invisible"
                type="file"
                [multiple]="false"
                [accept]="'image/jpeg, image/png'"
                (change)="uploadAvatar($event)"
                #avatarFileInput
              />
              <label
                for="profile-avatar-file-input"
                class="flex items-center justify-center w-10 h-10 cursor-pointer rounded-full hover:bg-hover"
                matRipple
              >
                <mat-icon class="text-white" [svgIcon]="'heroicons_outline:camera'"></mat-icon>
              </label>
            </div>
            <div>
              <button
                mat-icon-button
                (click)="uploadAvatar(undefined); avatarFileInput.value = null"
              >
                <mat-icon class="text-white" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <form class="w-full mt-1" [formGroup]="userProfileForm">
        <mat-expansion-panel #mep="matExpansionPanel" class="m-1">
          <mat-expansion-panel-header>Basic Information</mat-expansion-panel-header>
          <div
            class="flex flex-col items-center justify-center md:justify-between lg:justify-between lg:flex-row"
          >
            <span class="min-[1200px]:flex-none min-[1200px]:w-[50.0%] flex-none w-full flex">
              <div
                [class.py-3]="!isEditing"
                [class.px-1]="!isEditing"
                class="flex-none w-[33.33333333%] border border-gray-300 flex items-center justify-center"
              >
                <div class="flex items-center justify-center">
                  <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:user'"></mat-icon>
                </div>
                <div>First Name</div>
              </div>
              <div
                [class.py-3]="!isEditing"
                [class.px-1]="!isEditing"
                class="flex-none w-[66.66666667%] border border-gray-300 flex items-center justify-center"
              >
                <span
                  *ngIf="!isEditing"
                  class="ml-2 text-primary w-full flex justify-center items-center"
                  >{{ userData.first_name }}</span
                >
                <span *ngIf="isEditing" class="inp my-1ut-with-error my-1 mx-2 w-full">
                  <mat-form-field subscriptSizing="dynamic" class="w-full">
                    <input matInput placeholder="First Name" formControlName="first_name" />
                    <mat-error
                      class="mt-1"
                      *ngIf="userProfileForm.get('first_name').hasError('required') && isEditing"
                    >
                      First Name is required
                    </mat-error>
                  </mat-form-field>
                </span>
              </div>
            </span>

            <span class="min-[1200px]:flex-none min-[1200px]:w-[50.0%] flex-none w-full flex">
              <div
                [class.py-3]="!isEditing"
                [class.px-1]="!isEditing"
                class="flex-none w-[33.33333333%] border border-gray-300 flex items-center justify-center"
              >
                <div class="flex items-center justify-center">
                  <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:user'"></mat-icon>
                </div>
                <div>Last Name</div>
              </div>
              <div
                [class.py-3]="!isEditing"
                [class.px-1]="!isEditing"
                class="flex-none w-[66.66666667%] border border-gray-300 flex items-center justify-center"
              >
                <span
                  *ngIf="!isEditing"
                  class="ml-2 text-primary w-full flex justify-center items-center"
                  >{{ userData.last_name }}</span
                >
                <span *ngIf="isEditing" class="inp my-1ut-with-error my-1 mx-2 w-full">
                  <mat-form-field subscriptSizing="dynamic" class="w-full">
                    <input matInput placeholder="Last Name" formControlName="last_name" />
                    <mat-error
                      class="mt-1"
                      *ngIf="userProfileForm.get('last_name').hasError('required') && isEditing"
                    >
                      Last Name is required
                    </mat-error>
                  </mat-form-field>
                </span>
              </div>
            </span>
          </div>

          <div
            class="flex flex-col items-center justify-center md:justify-between lg:justify-between lg:flex-row"
          >
            <span class="min-[1200px]:flex-none min-[1200px]:w-[50.0%] flex-none w-full flex">
              <div
                [class.py-3]="!isEditing"
                [class.px-1]="!isEditing"
                class="flex-none w-[33.33333333%] border border-gray-300 flex items-center justify-center"
              >
                <div class="flex items-center justify-center">
                  <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
                </div>
                <div>Email</div>
              </div>
              <div
                [class.py-3]="!isEditing"
                [class.px-1]="!isEditing"
                class="flex-none w-[66.66666667%] border border-gray-300 flex items-center justify-center"
              >
                <span
                  class="ml-2 text-primary w-full flex justify-center items-center"
                  *ngIf="!isEditing"
                  >{{ userData.email }}</span
                >
                <span *ngIf="isEditing" class="inp my-1ut-with-error my-1 mx-2 w-full">
                  <mat-form-field subscriptSizing="dynamic" class="w-full">
                    <input matInput placeholder="Email" formControlName="email" />
                    <mat-error
                      class="mt-1"
                      *ngIf="userProfileForm.get('email').hasError('required') && isEditing"
                    >
                      Email is required
                    </mat-error>
                    <mat-error
                      class="mt-1"
                      *ngIf="userProfileForm.get('email').hasError('email') && isEditing"
                    >
                      Please enter a valid email address
                    </mat-error>
                  </mat-form-field>
                </span>
              </div>
            </span>

            <span class="min-[1200px]:flex-none min-[1200px]:w-[50.0%] flex-none w-full flex">
              <div
                [class.py-3]="!isEditing"
                [class.px-1]="!isEditing"
                class="flex-none w-[33.33333333%] border border-gray-300 flex items-center justify-center"
              >
                <div class="flex items-center justify-center">
                  <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:identification'"></mat-icon>
                </div>
                <div>Username</div>
              </div>
              <div
                [class.py-3]="!isEditing"
                [class.px-1]="!isEditing"
                class="flex-none w-[66.66666667%] border border-gray-300 flex items-center justify-center"
              >
                <span
                  class="ml-2 text-primary w-full flex justify-center items-center"
                  *ngIf="!isEditing"
                  >{{ userData.username }}</span
                >
                <span *ngIf="isEditing" class="inp my-1ut-with-error my-1 mx-2 w-full">
                  <mat-form-field subscriptSizing="dynamic" class="w-full">
                    <input
                      matInput
                      placeholder="Username"
                      autocomplete="username"
                      formControlName="username"
                    />
                    <mat-error
                      class="mt-1"
                      *ngIf="userProfileForm.get('username').hasError('required') && isEditing"
                    >
                      Username is required
                    </mat-error>
                  </mat-form-field>
                </span>
              </div>
            </span>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="m-1">
          <mat-expansion-panel-header>Roles Information</mat-expansion-panel-header>

          <div
            class="flex flex-col items-center justify-center md:justify-between lg:justify-between lg:flex-row"
          >
            <span class="min-[1200px]:flex-none min-[1200px]:w-[50.0%] flex-none w-full flex">
              <div
                class="flex-none w-[33.33333333%] border py-[1rem] px-1 border-gray-300 flex items-center justify-center"
              >
                <div class="flex items-center justify-center">
                  <mat-icon class="mr-1" [svgIcon]="'mat_outline:laptop_mac'"></mat-icon>
                </div>
                <div>Role</div>
              </div>
              <div
                class="flex-none w-[66.66666667%] border py-[1rem] px-1 border-gray-300 flex items-center justify-center"
              >
                <span class="ml-2 text-primary w-full flex justify-center items-center">{{
                  userData.coach.roles
                }}</span>
              </div>
            </span>

            <span class="min-[1200px]:flex-none min-[1200px]:w-[50.0%] flex-none w-full flex">
              <div
                class="flex-none w-[33.33333333%] border py-[1rem] px-1 border-gray-300 flex items-center justify-center"
              >
                <div
                  class="flex items-center justify-center"
                  class="flex-none w-[25.0%] flex items-center justify-end"
                >
                  <mat-icon class="mr-1" [svgIcon]="'mat_outline:person_pin_circle'"></mat-icon>
                </div>
                <div class="flex-none w-[75.0%] flex items-center justify-start">
                  Position Group
                </div>
              </div>
              <div
                class="flex-none w-[66.66666667%] border py-[1rem] px-1 border-gray-300 flex items-center justify-center"
              >
                <span class="ml-2 text-primary w-full flex justify-center items-center">{{
                  userData.coach.postion_group ?? '-'
                }}</span>
              </div>
            </span>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="m-1">
          <mat-expansion-panel-header>Package Information</mat-expansion-panel-header>
          <div
            class="flex flex-col items-center justify-center md:justify-between lg:justify-between lg:flex-row"
          >
            <span class="min-[1200px]:flex-none min-[1200px]:w-[50.0%] flex-none w-full flex">
              <div
                class="flex-none w-[41.66666667%] border border-gray-300 py-[1rem] px-1 flex items-center justify-center"
              >
                <div class="flex items-center justify-center">
                  <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                </div>
                <div>Date Joined</div>
              </div>
              <div
                [class.py-3]="!isEditing"
                [class.px-1]="!isEditing"
                class="flex-none w-[58.33333333%] border border-gray-300 flex items-center justify-center"
              >
                <span class="ml-2 text-primary w-full flex justify-center items-center">{{
                  userData.coach.coach_info.date_joined | date: 'MMM d, y'
                }}</span>
              </div>
            </span>

            <span class="min-[1200px]:flex-none min-[1200px]:w-[50.0%] flex-none w-full flex">
              <div
                class="flex-none w-[41.66666667%] border border-gray-300 py-[1rem] px-1 flex items-center justify-center"
              >
                <div class="flex items-center justify-center">
                  <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:list-bullet'"></mat-icon>
                </div>
                <div>Package Details</div>
              </div>
              <div
                class="flex-none w-[58.33333333%] border border-gray-300 flex items-center justify-center"
              >
                <span class="ml-2 text-primary w-full flex justify-center items-center">
                  {{ userData.coach.subscription_info[0]?.package_name }} <br />
                  {{
                    $safeNavigationMigration(userData.coach.subscription_info[0]?.start_date)
                      | date: 'MMM d, y'
                  }}
                  &nbsp; - &nbsp;
                  {{
                    $safeNavigationMigration(userData.coach.subscription_info[0]?.end_date)
                      | date: 'MMM d, y'
                  }}</span
                >
              </div>
            </span>
          </div>

          <div
            class="flex flex-col items-center justify-center md:justify-between lg:justify-between lg:flex-row"
          >
            <span class="min-[1200px]:flex-none min-[1200px]:w-[50.0%] flex-none w-full flex">
              <div
                class="flex-none w-[41.66666667%] border border-gray-300 py-[1rem] px-1 flex items-center justify-center"
              >
                <div class="flex items-center justify-center">
                  <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:clock'"></mat-icon>
                </div>
                <div>Video Quota Details</div>
              </div>
              <div
                class="flex-none w-[58.33333333%] border border-gray-300 flex items-center justify-center"
              >
                <span class="ml-2 text-primary w-full flex justify-center items-center">
                  <b>{{ userData.club.utilized_video_quota_in_hours }}</b
                  >&nbsp;hours /&nbsp;
                  <b>
                    {{ userData.club.video_quota_in_hours }}
                  </b>
                  &nbsp;hours
                </span>
              </div>
            </span>
          </div>
        </mat-expansion-panel>
      </form>

      <form class="w-full mt-1" [formGroup]="changePasswordForm">
        <mat-expansion-panel
          [disabled]="!isPasswordChangeEnabled.value"
          [expanded]="isPasswordChangeEnabled.value"
        >
          <mat-expansion-panel-header>
            <div class="flex justify-between items-center w-full mr-2">
              <div>Change Password</div>
              <div>
                <mat-slide-toggle
                  color="primary"
                  labelPosition="before"
                  [formControl]="isPasswordChangeEnabled"
                  (click)="$event.stopPropagation()"
                >
                  Enable Change Password
                </mat-slide-toggle>
              </div>
            </div>
          </mat-expansion-panel-header>

          <div>
            <div
              class="flex flex-col items-center justify-center md:justify-between lg:justify-between lg:flex-row"
            >
              <span class="flex-none w-full flex">
                <div
                  class="flex-none w-[33.33333333%] border border-gray-300 flex items-center justify-center"
                >
                  <div class="flex items-center justify-center">
                    <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:key'"></mat-icon>
                  </div>
                  <div>Old Password</div>
                </div>
                <div
                  class="flex-none w-[66.66666667%] border border-gray-300 flex items-center justify-center"
                >
                  <span class="input-with-error mx-2 my-1 w-1/2">
                    <mat-form-field subscriptSizing="dynamic" class="w-full">
                      <input
                        matInput
                        placeholder="Old Password:"
                        formControlName="old_password"
                        #currentPasswordField
                      />
                      <button
                        (click)="
                          currentPasswordField.type === 'password'
                            ? (currentPasswordField.type = 'text')
                            : (currentPasswordField.type = 'password')
                        "
                        mat-icon-button
                        matSuffix
                        type="button"
                      >
                        <mat-icon
                          *ngIf="currentPasswordField.type === 'password'"
                          [svgIcon]="'heroicons_solid:eye'"
                          class="icon-size-5"
                        ></mat-icon>
                        <mat-icon
                          *ngIf="currentPasswordField.type === 'text'"
                          [svgIcon]="'heroicons_solid:eye-slash'"
                          class="icon-size-5"
                        ></mat-icon>
                      </button>
                    </mat-form-field>
                  </span>
                </div>
              </span>
            </div>

            <div class="flex flex-col">
              <div class="flex-none w-full flex">
                <div
                  class="flex-none w-[33.33333333%] border border-gray-300 flex items-center justify-center"
                >
                  <div class="flex items-center justify-center">
                    <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:key'"></mat-icon>
                  </div>
                  <div>New Password</div>
                </div>
                <div
                  class="flex-none w-[66.66666667%] border border-gray-300 flex items-center justify-center"
                >
                  <span class="input-with-error mx-2 my-1 w-1/2">
                    <mat-form-field subscriptSizing="dynamic" class="w-full">
                      <input
                        matInput
                        placeholder="New Password"
                        formControlName="new_password1"
                        autocomplete="password"
                        #newPasswordField
                      />
                      <button
                        (click)="
                          newPasswordField.type === 'password'
                            ? (newPasswordField.type = 'text')
                            : (newPasswordField.type = 'password')
                        "
                        mat-icon-button
                        matSuffix
                        type="button"
                      >
                        <mat-icon
                          *ngIf="newPasswordField.type === 'password'"
                          [svgIcon]="'heroicons_solid:eye'"
                          class="icon-size-5"
                        ></mat-icon>
                        <mat-icon
                          *ngIf="newPasswordField.type === 'text'"
                          [svgIcon]="'heroicons_solid:eye-slash'"
                          class="icon-size-5"
                        ></mat-icon>
                      </button>
                      <mat-error
                        *ngIf="changePasswordForm.get('new_password1').hasError('required')"
                      >
                        New Password is required
                      </mat-error>
                      <mat-error
                        *ngIf="changePasswordForm.get('new_password1').hasError('minlength')"
                      >
                        Password must contain a minimum of 8 characters.
                      </mat-error>
                    </mat-form-field>
                  </span>
                </div>
              </div>
              <div class="flex-none w-full flex">
                <div
                  class="flex-none w-[33.33333333%] border border-gray-300 flex items-center justify-center"
                >
                  <div class="flex items-center justify-center">
                    <mat-icon class="mr-1" [svgIcon]="'heroicons_outline:key'"></mat-icon>
                  </div>
                  <div>Confirm Password</div>
                </div>
                <div
                  class="flex-none w-[66.66666667%] border border-gray-300 flex items-center justify-center"
                >
                  <span class="input-with-error mx-2 my-1 w-1/2">
                    <mat-form-field subscriptSizing="dynamic" class="w-full">
                      <input
                        matInput
                        placeholder="Confirm Password"
                        formControlName="new_password2"
                        autocomplete="password"
                        #newPassword2Field
                      />
                      <button
                        (click)="
                          newPassword2Field.type === 'password'
                            ? (newPassword2Field.type = 'text')
                            : (newPassword2Field.type = 'password')
                        "
                        mat-icon-button
                        matSuffix
                        type="button"
                      >
                        <mat-icon
                          *ngIf="newPassword2Field.type === 'password'"
                          [svgIcon]="'heroicons_solid:eye'"
                          class="icon-size-5"
                        ></mat-icon>
                        <mat-icon
                          *ngIf="newPassword2Field.type === 'text'"
                          [svgIcon]="'heroicons_solid:eye-slash'"
                          class="icon-size-5"
                        ></mat-icon>
                      </button>
                      <mat-error
                        class="mt-1"
                        *ngIf="changePasswordForm.get('new_password2').hasError('required')"
                      >
                        Password confirmation is required
                      </mat-error>
                      <mat-error
                        class="mt-1"
                        *ngIf="changePasswordForm.get('new_password2').hasError('mustMatch')"
                      >
                        Passwords must match
                      </mat-error>
                    </mat-form-field>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <mat-action-row>
            <button
              mat-raised-button
              color="primary"
              [disabled]="isPasswordChangeEnabled && !changePasswordForm.valid"
              (click)="changePassword()"
            >
              Change Password
            </button>
          </mat-action-row>
        </mat-expansion-panel>
      </form>

      <div class="flex items-center justify-center p-1 pt-[1.5rem]">
        <button
          *ngIf="!isEditing"
          class="m-2"
          mat-raised-button
          color="primary"
          (click)="mep.expanded = true; editFields()"
        >
          Edit
        </button>

        <button *ngIf="!isEditing" class="m-2" mat-raised-button (click)="home()">Exit</button>

        <button
          *ngIf="isEditing"
          class="m-2"
          mat-raised-button
          color="primary"
          [disabled]="!userProfileForm.valid"
          (click)="submit()"
        >
          Save
        </button>

        <button
          *ngIf="isEditing"
          class="m-2"
          mat-raised-button
          (click)="mep.expanded = false; clearForm()"
        >
          Cancel
        </button>
      </div>
    </div>
  </og-card>
</div>
